import React from 'react';
import { useNavigate } from 'react-router-dom';

function KVKKPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">KVKK - Kişisel Verilerin Korunması</h1>
          <div className="w-6"></div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-5xl mx-auto py-12 px-4">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-700 mb-6">
            KİŞİSEL VERİLERİN KORUNMASI VE İŞLENMESİ HAKKINDA POTANSİYEL MÜŞTERİYE YÖNELİK AÇIK RIZA
          </h2>
          
          <p className="text-gray-600 mb-6">
            Kişisel verilerin korunması Meksa Yatırım Menkul Değerler A.Ş'nin (Şirketimiz) en önemli öncelikleri arasındadır.
          </p>

          <div className="mb-6">
            <h3 className="font-bold text-gray-700 mb-3">İşlenecek Kişisel Verileriniz:</h3>
            <ol className="list-decimal list-inside space-y-2 text-gray-600">
              <li>Kimlik Bilgileri: Ad-Soyad, TCKN/VKN</li>
              <li>İletişim Bilgiler: Adres bilgisi, E-posta adresi, Telefon numarası</li>
            </ol>
          </div>

          <div className="mb-6">
            <h3 className="font-bold text-gray-700 mb-3">İşlenme Amaçları:</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>İletişim kurulması</li>
              <li>Hizmeti değerlendirmek için bilgilerin kaydedilmesi</li>
              <li>Özellikli hizmetler sunmak için analiz ve istihbarat çalışmalarının yürütülmesi</li>
              <li>Destek sürecine ilişkin hizmet kalitesinin ölçülmesi ve geliştirilmesi</li>
              <li>Denetim ve kontrol süreçleri için dolandırıcılığın tespiti ve önlenmesi, risk yönetimi ve kontrol faaliyetlerinin gerçekleştirilmesi</li>
              <li>Tanıtım, pazarlama ve promosyon faaliyetleri yürütülmesi</li>
            </ul>
          </div>

          <p className="text-gray-600 mb-8">
            Kişisel verileriniz, ticari elektronik iletilerin gönderilmesi konusunda anlaşmalı olduğumuz kuruluşlara, 
            program ortağı kuruluşlara ve yurt içi ilişkili olduğumuz kuruluşlarla belirtilen amaçlarla sınırlı ve 
            orantılı olmak üzere aktarabilecektir.
          </p>

          <div className="bg-gray-100 p-6 rounded-lg">
            <p className="text-sm text-gray-600 italic">
              Kişisel verilerimin yukarıda belirtilen şekilde işlenmesini açık rızam ile kabul ediyorum.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KVKKPage;
